import { render } from "./Greeting.vue?vue&type=template&id=05a9d2d6&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=05a9d2d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a9d2d6"]])

export default __exports__